import { IonInput, IonLoading, IonRouterLink, IonText } from '@ionic/react'
import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { useSignIn } from '../../../modules/auth'
import { Box } from '../../atoms'

const DarkInput = styled(IonInput)`
  --background: rgba(255, 255, 255, 0.1);
  --color: white;
  --placeholder-color: rgba(255, 255, 255, 0.45);
  font-family: 'Montserrat', 'SF Pro Display', sans-serif;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  font-size: 14px;
  height: 48px;
  padding: 0 16px !important;
  overflow: hidden;
`

interface SendData {
  email: string
  password: string
}

export const Login = () => {
  const { isLoading, handleSignInWithEmailAndPassword } = useSignIn()

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validateOnChange: true,
    validateOnBlur: false,
    validate: values => {
      const errors: Partial<SendData> = {}
      if (!values.email) {
        errors.email = 'メールアドレスは必須です'
      }
      if (!values.password) {
        errors.password = 'パスワードは必須です'
      }
      return errors
    },
    onSubmit: values => {
      if (values.email && values.password) {
        handleSignInWithEmailAndPassword({ email: values.email.toString(), password: values.password.toString() })
      }
    }
  })
  const isSp = useMediaQuery({
    query: '(max-device-width: 500px)'
  })

  const { email, password } = formik.values

  // 2) 値の注入→検証→送信まで一括
  useEffect(() => {
    ;(window as any).nativeFillAndSubmitLogin = async (email: string, password: string) => {
      // 値をセット（触った扱いにしてバリデーションも走らせる）
      formik.setFieldValue('email', email, false)
      formik.setFieldTouched('email', true, false)
      formik.setFieldValue('password', password, false)
      formik.setFieldTouched('password', true, false)

      const errs = await formik.validateForm({ email, password } as any)
      if (Object.keys(errs).length !== 0) {
        formik.setErrors(errs)
        return false
      }
      await formik.submitForm()
      return true // 成否を返す（API成功まで厳密に判定したいなら onSubmit 内で window.__nativeLoginResolve を使う拡張も可）
    }
    return () => {
      delete (window as any).nativeFillAndSubmitLogin
    }
  }, [formik])

  // 最新の values で validate → OKなら submit
  //      const errs = await formik.validateForm({
  //        email,
  //        password,
  //      } as any);
  //      if (Object.keys(errs).length === 0) {
  //        await formik.submitForm();
  //        return true;
  //      } else {
  //        // 必要ならエラーを画面に反映
  //        formik.setErrors(errs);
  //        return false;
  //      }
  //    };
  //    return () => { delete (window as any).nativeFillAndSubmitLogin; };
  //  }, [formik]);

  return (
    <>
      <IonLoading isOpen={isLoading} />

      {/* ロゴ */}
      <Box mb={isSp ? '48px' : '56px'} display="flex" justifyContent="center">
        <img
          src="/assets/logo-white.png"
          alt="CONNECT VIEW"
          style={{ height: isSp ? '72px' : '90px', width: 'auto', objectFit: 'contain' }}
        />
      </Box>

      {/* フォーム */}
      <Box width={isSp ? '100%' : '400px'} px={isSp ? '32px' : '0'}>
        <form onSubmit={formik.handleSubmit}>
          <Box mb="16px">
            <DarkInput
              name="email"
              type="email"
              placeholder="メールアドレス"
              required
              value={email}
              onIonChange={formik.handleChange}
              mode="md"
            />
          </Box>
          <Box mb="32px">
            <DarkInput
              name="password"
              type="password"
              placeholder="パスワード"
              required
              value={password}
              onIonChange={formik.handleChange}
              mode="md"
            />
          </Box>

          <Box mb="16px">
            <button
              type="submit"
              disabled={isLoading || !formik.isValid}
              style={{
                width: '100%',
                height: '48px',
                backgroundColor: 'white',
                border: 'none',
                borderRadius: '12px',
                color: '#303030',
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 700,
                fontSize: '14px',
                letterSpacing: '0.05em',
                cursor: isLoading || !formik.isValid ? 'not-allowed' : 'pointer',
                opacity: isLoading || !formik.isValid ? 0.5 : 1,
                transition: 'opacity 0.2s'
              }}
            >
              ログイン
            </button>
          </Box>

          <Box textAlign="center" mb={isSp ? '16px' : '0'}>
            <IonRouterLink routerLink="/password-reset" routerDirection="forward">
              <IonText>
                <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '12px', letterSpacing: '0.03em' }}>
                  パスワードを忘れた方へ
                </p>
              </IonText>
            </IonRouterLink>
          </Box>
        </form>

        {isSp && (
          <Box display="flex" mb="60px" mt="24px">
            <IonRouterLink
              routerLink="term-of-service"
              routerDirection="forward"
              style={{
                textDecoration: 'underline',
                textAlign: 'center',
                width: '100%',
                fontSize: '11px',
                color: 'rgba(255,255,255,0.35)',
                lineHeight: '18px'
              }}
            >
              利用規約
            </IonRouterLink>
          </Box>
        )}
      </Box>
    </>
  )
}
